import { getTag, getTags, getTagsSearchFilter, patchTag } from '../../api/tags';
import { Tag, TagSearchFilterParam, TagsParams } from '../../interfaces/api/tag';

export async function fetchTags(): Promise<Tag[]> {
	try {
		return await getTags();
	} catch (error) {
		throw error;
	}
}

export async function fetchTag(id: number): Promise<Tag> {
	try {
		return await getTag(id);
	} catch (error) {
		throw error;
	}
}

export async function fetchTagsSearchFilter(params: TagSearchFilterParam): Promise<Tag[]> {
	try {
		return await getTagsSearchFilter(params);
	} catch (error) {
		throw error;
	}
}

export async function updateTag(id: number, params: TagsParams): Promise<Tag> {
	try {
		return await patchTag(id, params);
	} catch (error) {
		throw error;
	}
}
